import type { BoardToolId } from "./types";

export type ShapesGroupToolId = "line" | "arrow" | "shape";

const STORAGE_KEY = "wb-shapes-group-tool";

export function isShapesGroupTool(id: BoardToolId | string): id is ShapesGroupToolId {
  return id === "line" || id === "arrow" || id === "shape";
}

function loadLast(): ShapesGroupToolId {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw === "line" || raw === "arrow" || raw === "shape") return raw;
  } catch {
    /* ignore */
  }
  return "shape";
}

let lastTool: ShapesGroupToolId = loadLast();

export function getLastShapesGroupTool(): ShapesGroupToolId {
  return lastTool;
}

export function setLastShapesGroupTool(id: ShapesGroupToolId): void {
  lastTool = id;
  try {
    sessionStorage.setItem(STORAGE_KEY, id);
  } catch {
    /* ignore */
  }
}

/** Линия и стрелка живут в отделе «Фигуры», на рейке их не показываем. */
export function isShapesGroupRailHidden(id: BoardToolId): boolean {
  return id === "line" || id === "arrow";
}
